import { Routes, Route, Navigate } from "react-router-dom";
import { Suspense, lazy } from "react";
import { LanguageProvider } from "../context/LanguageContext";
import Blog from "../pages/Blog";
import BlogDetails from "../pages/BlogDetails";
import DeleteUser from "../pages/DeleteUser";

export const Loadable = (Component) => (props) => {
  return (
    <Suspense>
      <Component {...props} />
    </Suspense>
  );
};

const Home = Loadable(lazy(() => import("../pages")));

const LanguageRoutes = () => (
  <LanguageProvider>
    <Routes>
      <Route index element={<Home />} />
      <Route path="blog" element={<Blog />} />
      <Route path="blog/:id" element={<BlogDetails />} />
    </Routes>
  </LanguageProvider>
);

const Router = () => {
  return (
    <>
      <Routes>
        {/* Language-prefixed routes */}
        <Route path="/:lang/*" element={<LanguageRoutes />} />

        {/* Default: redirect / to /ar */}
        <Route path="/" element={<Navigate to="/ar" replace />} />

        {/* Backward compat: /blog → /ar/blog */}
        <Route path="/blog" element={<Navigate to="/ar/blog" replace />} />

        {/* Legacy blog_details → /ar/blog */}
        <Route path="/blog_details" element={<Navigate to="/ar/blog" replace />} />

        {/* Non-language pages */}
        <Route path="/delete_user" element={<DeleteUser />} />
      </Routes>
    </>
  );
};

export default Router;
